import React from 'react';
const detail = [
    {
        type: 'block',
        component: 'SceneIntroduction',
        props: {
            title: '场景介绍',
            children: [
                {
                    // 版本说明
                    type: 'baseList',
                    component: 'BaseList',
                    props: {
                        title: '版本说明',
                        className: 'version-wrapper',
                        render(item, index) {
                            return (<div key={index} className="base-list-item">
                  <p>
                    <span>{item.version}</span>
                    <span>{item.info}</span>
                  </p>
                  <p>{item.dateStr}</p>
                </div>);
                        },
                    },
                    transform(state) {
                        const { introduction } = state;
                        const { versionsInfo } = introduction;
                        if (!versionsInfo || versionsInfo.length === 0) {
                            return false;
                        }
                        return {
                            list: versionsInfo,
                        };
                    },
                },
            ],
        },
        transform(state) {
            const { introduction } = state;
            if (!introduction) {
                return false;
            }
            return {
                text: introduction.sceneDesc,
                atlas: introduction.showPic,
            };
        },
    },
    {
        type: 'block',
        component: 'DataEffect',
        props: {
            title: '数据效果',
            children: [],
        },
        transform(state) {
            const { dataEffectValue } = state;
            if (!dataEffectValue || (!dataEffectValue.showKeyIndexes && !dataEffectValue.showRecommendIndexes && !dataEffectValue.showRelatedIndexes)) {
                return false;
            }
            return {
                dataEffectValue: dataEffectValue,
            };
        },
    },
    {
        type: 'block',
        component: 'InterfaceExperience',
        props: {
            title: '接口体验',
        },
        transform(state) {
            const { interfaceExperience } = state;
            if (!interfaceExperience || !interfaceExperience.params) {
                return false;
            }
            const connectUrl = `${interfaceExperience.url}/${interfaceExperience.params.interfaceType}?id=${interfaceExperience.params.interfaceId}`;
            return {
                url: connectUrl,
            };
        },
    },
];
export default detail;
